import Checkbox from '../../../../../components/Checkbox'
import { controlList, reqSummaryData } from '../../../storage'
import { render } from 'redity'
import { Keys } from '../../../constants'

export default function CheckboxOnlyInventory() {
    const { value, setParam } = controlList.useParam('only_inventory')
    async function onChange() {
        const temp = value === 'true'
        setParam((!temp).toString())
        reqSummaryData.setQuery('only_inventory', (!temp).toString())
        await reqSummaryData.load()
        render(Keys.HEADER)
    }

    return (
        <div className="mr-2">
            <label className="flex items-center text-neutral text-xs underline">
                <Checkbox checked={value === 'true'} onChange={onChange} />{' '}
                <div className="ml-1">Solo bodegas de inventario</div>
            </label>
        </div>
    )
}
